<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col sm="10">
                <div class="section mb-15 p-15 bg-light">
                    <h2 class="3">Login</h2>
                    <router-link class="btn btn-primary" to="/login">Einloggen</router-link>
                </div>
            </b-col>
            <b-col sm="10">
                <div class="section mb-15 p-15 bg-light">
                    <h2>Registrierung</h2>
                    <router-link class="btn btn-primary mr-15" to="/aktivierung">Altkunde</router-link>
                    <router-link class="btn btn-primary" to="/registrierung">Neukunde</router-link>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    export default {
        name: 'indexView'
    };
</script>